import { HttpParams } from '@angular/common/http';

import { toHTTPParam } from '../../../../core';
import { Filter } from '../../../../models';

/** Representa o Filter da entidade Transportadora */
export class TransportadoraFilter implements Filter {
    situacao: number;
    nomeCodigoCnpjCpf: string;
    cnpjCpf: string;
    codigoIntegracaoErp: string;
    dataCadastroInicial: Date;
    dataCadastroFinal: Date;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        // Nome / Código Integração / CNPJ/CPF
        if (this.nomeCodigoCnpjCpf && this.nomeCodigoCnpjCpf.trim().length > 0) {
            params = params.append('nomeCodigoCnpjCpf', this.nomeCodigoCnpjCpf);
        }
        // CNPJ/CPF
        if (this.cnpjCpf && this.cnpjCpf.trim().length > 0) {
            params = params.append('cnpjCpf', this.cnpjCpf);
        }
        // Código Integração ERP
        if (this.codigoIntegracaoErp && this.codigoIntegracaoErp.trim().length > 0) {
            params = params.append('codigoIntegracaoErp', this.codigoIntegracaoErp);
        }

        // Data de Cadastro
        if (this.dataCadastroInicial) {
            params = params.append('dataCadastroInicial', toHTTPParam(this.dataCadastroInicial));
        }
        if (this.dataCadastroFinal) {
            params = params.append('dataCadastroFinal', toHTTPParam(this.dataCadastroFinal));
        }

        return params;
    }

    clear() {
        this.situacao = null;
        this.nomeCodigoCnpjCpf = null;
        this.cnpjCpf = null;
        this.codigoIntegracaoErp = null;
        this.dataCadastroInicial = null;
        this.dataCadastroFinal = null;
    }
}

